import { ArticlePage, LegalPage } from 'components';

export const legalRoutes = {
  about: {
    path: '/qui-sommes-nous',
    component: () => <ArticlePage type="about" />
  },
  insurance: {
    path: '/assurance',
    component: () => <LegalPage type="insurance" />
  },
  privacy: {
    path: '/politique-de-confidentialite',
    component: () => <LegalPage type="terms" />
  },
  terms: {
    path: '/mentions-legales',
    component: () => <LegalPage type="terms" />
  },
  termsOfSales: {
    path: '/conditions-generales-de-vente',
    component: () => <LegalPage type="terms-of-sales" />
  },
  trustUs: {
    path: '/ils-nous-font-confiance',
    component: () => <ArticlePage type="trust-us" />
  }
};
